/* eslint-disable import/no-named-as-default */
"use client";

import { Vehicle } from "@alba-cars/common-modules";
import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

import PhoneNumberModal from "@/components/common/modals/PhoneNumberModal";
import Button from "@/components/ui/buttons/Button";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { slugify } from "@/lib/utils";
import { phoneNumber } from "@/utils/constants";

interface MobileButtonsProps {
  car: Vehicle;
}

export default function MobileButtons({ car }: MobileButtonsProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);

  const isTabletOrLarger = useMediaQuery("(min-width: 768px)");

  const trim = car?.trim ?? "";
  const refId = car?.refId ?? "";
  const make = car?.make?.name ?? "";
  const model = car?.model?.name ?? "";
  const detailLink = trim
    ? `${refId}-${slugify(make)}-${slugify(model)}-${slugify(trim)}`
    : `${refId}-${slugify(make)}-${slugify(model)}`;

  return (
    <>
      <div className="flex space-x-4">
        <Button
          buttonText="Call Us"
          bgColor="primary-light"
          textColor="primary"
          className="my-2 w-1/2 py-4 text-center hover:bg-primary hover:text-white"
          onClick={() => {
            if (isTabletOrLarger) {
              setIsPhoneNumberModalOpen(true);
            } else {
              window.location.href = `tel:${phoneNumber}`;
            }
          }}
        />
        <Button
          buttonText="Buy this Car"
          bgColor="primary-light"
          textColor="primary"
          className="my-2 w-1/2 py-4 text-center hover:bg-primary hover:text-white"
          onClick={() => {
            const params = new URLSearchParams(searchParams);
            params.set("deposit", "5000");
            router.push(`/book_car/${detailLink}?${params.toString()}`);
          }}
        />
      </div>
      <PhoneNumberModal
        isOpen={isPhoneNumberModalOpen}
        onClose={() => setIsPhoneNumberModalOpen(false)}
        phoneNumber={phoneNumber}
      />
    </>
  );
}
